/**
 * @license BCP
 * (c) 2016 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * @author Dmitry Mishin dmishin@openprovider.ru
 * License: MIT
 */
(function() {'use strict';

/**
 * @ngdoc module
 * @name promotions
 * @description
 *
 * # promotions
 *
 * The `promotions` module provides promotions managment - list/search/filter/change.
 */
angular.module("promotions", [])
  .constant("promotionListDefaultPageSize", 10)
  .constant("promotionListPageSizes", [10, 25, 50, 100])
  .constant("promotionListControlSize", 10)
/**
 * @ngdoc controller
 * @name promotionListCtrl
 * @requires $scope, $modal, $location, $aside, b17Service, userCache, auth
 *
 * @description
 * Promotion list Controller
 */
  .controller("promotionListCtrl", function (
    $scope, $modal, $location, $aside, b17Service, userCache, auth,
    promotionListDefaultPageSize, promotionListPageSizes, promotionListControlSize, exportToCsv
  ) {

    // init error message
    $scope.errorMessage = null;

    $scope.location = $location.path();

    $scope.data = {};
    $scope.data.versions = [];
    // init promotion type
    var selectedType = userCache.get('promotionListSelectedType');
    // init price version
    var selectedVersion = userCache.get('promotionListSelectedVersion');
    // init promotion name
    $scope.selectedName = userCache.get('promotionListSelectedName');
    // init bind value (resellers #)
    $scope.selectedBind = userCache.get('promotionListSelectedBind');
    // init product value (product)
    $scope.selectedProduct = userCache.get('promotionListSelectedProduct');

    // -------------
    // GET REST DATA
    // -------------

    // get config data
    b17Service.getConfig().then(function (config) {
      if (config.data && config.data.data) {
        $scope.data.config = config.data.data.results[0];
        if (angular.isUndefined(selectedVersion)) {
          selectedVersion = $scope.data.config.version;
        }
      } else {
        checkErrorCodeMessage();
      }
    });

    // get editions data (price versions without promotions)
    b17Service.getEditions().then(function (editions) {
      if (editions.data && editions.data.data) {
        $scope.data.versions = editions.data.data.results;
      } else {
        checkErrorCodeMessage();
      }
    });

    // get promotions data
    b17Service.getPromotions().then(function (promotions) {
      if (promotions.data && promotions.data.data) {
        $scope.data.promotions = promotions.data.data.results;
        $scope.data.products = [];

        $scope.data.promotions.forEach(function (promotion) {
          if (promotion.rules) {
            promotion.rules.forEach(function (rule) {
              $scope.data.products = $scope.data.products.concat(rule.products);
            });
          }
        });
        $scope.data.products = _.uniq($scope.data.products);
        $scope.data.products = $scope.data.products.map(function(product){
          return {name: product};
        });
      } else {
        checkErrorCodeMessage();
      }
    });

    // ----------
    // PAGINATION
    // ----------

    // init pagination
    $scope.defaultPageSize = promotionListDefaultPageSize;
    $scope.pageSize = userCache.get('promotionListPageSize') || promotionListDefaultPageSize;
    $scope.pageSizes = promotionListPageSizes;
    $scope.controlMaxSize = promotionListControlSize;
    $scope.currentPage = userCache.get('promotionListCurrentPage') || 1;

    $scope.pageChanged = function() {
      userCache.put('promotionListCurrentPage', $scope.currentPage);
    };

    // ---------
    // SELECTORS
    // ---------

    // select page size
    $scope.selectPageSize = function (count) {
      $scope.pageSize = count;
      userCache.put('promotionListPageSize', count);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select promotion type
    $scope.selectType = function (name) {
      selectedType = name;
      userCache.put('promotionListSelectedType', name);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select price version
    $scope.selectVersion = function (version) {
      selectedVersion = version;
      userCache.put('promotionListSelectedVersion', version);
      $scope.currentPage = 1;
      $scope.pageChanged();
    };

    // select promotion name
    $scope.selectName = function (name) {
      $scope.selectedName = name;
      userCache.put('promotionListSelectedName', name);
    };

    // select bind value (resellers #)
    $scope.selectBind = function (bind) {
      $scope.selectedBind = bind;
      userCache.put('promotionListSelectedBind', bind);
    };

    // select product
    $scope.selectProduct = function (product) {
      $scope.selectedProduct = product;
      userCache.put('promotionListSelectedProduct', product);
    };

    // -------
    // FILTERS
    // -------

    $scope.versionFilter = function (item) {
      return angular.isUndefined(selectedVersion) ||
        selectedVersion === null ||
        item.version === selectedVersion;
    };

    $scope.typeFilter = function (item) {
      return angular.isUndefined(selectedType) || 
        selectedType === null ||
        selectedType === '' ||
        selectedType === 'Conditional' && item.condition ||
        selectedType === 'Personal' && item.bind  && !angular.isArray(item.bind)||
        selectedType === 'Group' && item.bind && angular.isArray(item.bind) ||
        selectedType === 'Global' && !item.bind && !item.condition;
    };

    $scope.nameFilter = function (item) {
      return angular.isUndefined($scope.selectedName) || 
        $scope.selectedName === null ||
        $scope.selectedName === '' ||
        item.name === $scope.selectedName;
    };

    $scope.bindFilter = function (item) {
      return angular.isUndefined($scope.selectedBind) ||
        $scope.selectedBind === null ||
        $scope.selectedBind === '' ||
        angular.isDefined(item.bind) && item.bind.toString() === $scope.selectedBind.toString();
    };

    $scope.productFilter = function (item) {
      var result = false;

      if (angular.isUndefined($scope.selectedProduct) || !$scope.selectedProduct) {
        return true;
      }

      if (item.rules) {
        item.rules.forEach(function (rule) {
          if (angular.isDefined(rule.products) && rule.products.indexOf($scope.selectedProduct) > -1) {
            result = true;
          }
        });
      }

      return result;
    };

    // --------
    // WATCHERS
    // --------

    $scope.$watch('selectedName', function(newValue) {
      userCache.put('promotionListSelectedName', newValue);
    });

    $scope.$watch('selectedBind', function(newValue) {
      userCache.put('promotionListSelectedBind', newValue);
    });

    $scope.$watch('selectedProduct', function(newValue) {
      userCache.put('promotionListSelectedProduct', newValue);
    });

    // -------
    // GETTERS
    // -------

    // get promotion type
    $scope.getType = function () {
      return selectedType || 'All promotions';
    };

    // get version description
    $scope.getVersionDescription = function () {
      var versionDescription = "All versions";
      if (selectedVersion) {
        $scope.data.versions.forEach(function (version) {
          if (version.number === selectedVersion) {
            versionDescription = version.description;
          }
        });
      }
      return versionDescription;
    };

    // get promotion type description
    $scope.getTypeDescription = function (item) {
      if (item.condition) {
        return 'Conditional / ' + item.condition;
      }
      if (item.bind) {
        if (angular.isArray(item.bind)) {
          return 'Group / ' + item.bind.slice(0, 5).join(', ') + (item.bind.length > 5 ? ' ...' : '');
        } else {
          return 'Personal / ' + item.bind;
        }
      }
      return 'Global';
    };

    // get period 'from' description
    $scope.getPeriodFrom = function (item) {
      if (item.from) {
        return item.from + ' ' + (item.start ? item.start : '00:00:00') + ' CET';
      } else {
        return 'Unlimited';
      }
    };

    // get period 'to' description
    $scope.getPeriodTo = function (item) {
      if (item.to) {
        return item.to + ' ' + (item.stop ? item.stop : '23:59:59') + ' CET';
      } else {
        return 'Unlimited';
      }
    };

    // -------------------
    // BREADCRUMB & RESETS
    // -------------------

    $scope.checkBreadcrumb = function(name) {
      var version = ($scope.data.config && $scope.data.config.version) ? $scope.data.config.version : 1;

      switch (name) {
        case 'promotions':
          return selectedVersion !== version || selectedType ||
            $scope.selectedName || $scope.selectedBind;
        case 'versions':
          return selectedType || $scope.selectedName || $scope.selectedBind;
        case 'types':
          return $scope.selectedName || $scope.selectedBind;
        case 'names':
          return $scope.selectedBind;
      }
      return false;
    };

    $scope.resetAll = function () {
      $scope.selectProduct(null);
      $scope.selectBind(null);
      $scope.selectName(null);
      $scope.selectType(null);
      $scope.selectVersion($scope.data.config.version);
    };

    $scope.resetFilters = function(name) {
      switch (name) {
        case 'promotions':
          $scope.resetAll();
          return;
        case 'versions':
          $scope.selectBind(null);
          $scope.selectName(null);
          $scope.selectType(null);
          $scope.selectProduct(null);
         break;
        case 'types':
          $scope.selectBind(null);
          $scope.selectName(null);
          $scope.selectProduct(null);
         break;
        case 'names':
          $scope.selectBind(null);
      }
    };

    // ----------------------
    // ADD/CHANGE PRICE LINES
    // ----------------------

    // open promotion window
    $scope.openPromotion = function (item) {

      auth.checkUserData().then(function(userData) {
        if (userData.UID) {
          var promotionWindow = $modal.open({
            templateUrl: 'promotions/promotion.html',
            controller: 'promotionCtrl',
            size: 'xlg',
            backdrop: 'static',
            resolve: {
              promotion: function () {
                return item;
              }
            }
          });
          promotionWindow.result.then(function (message) {
            // renew promotions
            b17Service.getResponse().then(function (response) {
              b17Service.getPromotions({cache:false}).then(function (promotions) {
                if (promotions.data && promotions.data.data) {
                  $scope.data.promotions = promotions.data.data.results;
                } else {
                  checkErrorCodeMessage();
                }
              });
            });
            console.log(message);
          }, function () {
            console.log('Promotion changes dismissed at: ' + new Date());
          });
        } else {
          $aside.open({
            templateUrl: 'components/auth/login-form.html',
            placement: 'right',
            size: 'sm',
            backdrop: true,
            controller: 'loginFormCtrl'
          }).result.then(function (message) {
            console.log(message);
          });
        }
      });
    };

    // ---------------
    // ERRORS HANDLING
    // ---------------

    // clear error message
    $scope.dismissError = function() {
      $scope.errorMessage = null;
    };

    function checkErrorCodeMessage() {
      if (userCache.get('lastErrorCode')) {
        $scope.errorMessage = 'Error: (' + userCache.get('lastErrorCode') + ') ' + userCache.get('lastErrorMessage');
      } else {
        $scope.errorMessage = 'Unknown error, please check connection to service.';
      }
    }

    // ----------------------------------
    // EXPORT TO CSV, created by Eugene Semennikov
    // ----------------------------------

    $scope.exportAllProductRecordsToCsv = exportToCsv.downloadAllProductRecordsToFile;

  });

})();
